import { Box, debounce, InputAdornment, OutlinedInput, styled, SxProps } from '@mui/material';
import { ChangeEvent, FC, memo, useCallback, useState } from 'react';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: '100% !important',
  height: '40px !important',
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  sx?: SxProps;
  fullWidth?: boolean;
};

const SearchInput: FC<Props> = ({
  value: _value,
  onChange,
  placeholder,
  sx,
  fullWidth = false
}) => {
  const [value, setValue] = useState(_value);
  const debouncedOnChange = debounce(onChange, 200);
  const changeHandler = useCallback(
    (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      debouncedOnChange(e.target.value);
      setValue(e.target.value);
    },
    [debouncedOnChange]
  );

  return (
    <SearchStyle
      value={value}
      onChange={changeHandler}
      placeholder={placeholder || 'Поиск по имени или фамилии'}
      sx={{
        ...sx,
        maxWidth: fullWidth ? '100%' : '600px'
      }}
      startAdornment={
        <InputAdornment position="start">
          <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
        </InputAdornment>
      }
    />
  );
};

export default memo(SearchInput);
